import React, { Fragment, useMemo, useState } from 'react';
import AppTable from '../../../constants/AppTable';
import { LoadingSpinner } from '../../../constants/AppLoading';
import { Customer } from '../../../helpers/models/Models';
import ConsumerEditView from './dialog/ConsumerEditView';

interface CustomerListViewProps {
    data: {
        results: Customer[];
        previous: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
    setOnURL: React.Dispatch<React.SetStateAction<string>>;
    handleFormSuccess: () => void;
}

const CustomerListView: React.FC<CustomerListViewProps> = ({ data, loading, error, setOnURL, handleFormSuccess }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState<Customer | null>(null);
    const columns = [
        { header: 'SN', width: 0, accessor: 'member_sn', sortable: false },
        { header: 'Name', accessor: 'mem_name', sortable: false },
        { header: 'Spouse name.', width: 20, accessor: 'spouse_name', sortable: false },
        { header: 'Province', accessor: 'province_name', sortable: false },
        { header: 'Address', accessor: 'add_eng', sortable: false },
        { header: 'Address(Nepali)', accessor: 'add_nep', sortable: false },
        { header: 'Ward No.', accessor: 'ward_no', width: 0, sortable: false },
        { header: 'Phone No.', width: 10, accessor: 'phone_no', sortable: false },
        { header: 'DOB.', width: 10, accessor: 'dob', sortable: false },
        { header: 'Tole', width: 10, accessor: 'tole_name', sortable: false },
        { header: 'Father Name', width: 10, accessor: 'father_name', sortable: false },
        { header: 'Reg. Date.', width: 10, accessor: 'reg_date_n', sortable: false },
        { header: 'Meter con. Date.', width: 10, accessor: 'meter_conn_date', sortable: false },
        { header: 'Meter Status', width: 10, accessor: 'meter_status_name', sortable: false },
        { header: 'Tap No.', width: 10, accessor: 'tap_no', sortable: false },
        { header: 'Tap Status', width: 10, accessor: 'tap_status_name', sortable: false },
        { header: 'Gender', width: 10, accessor: 'gender_name', sortable: false },
        { header: 'F. Male No', width: 10, accessor: 'family_male_no', sortable: false },
        { header: 'F. Female No', width: 10, accessor: 'family_female_no', sortable: false },
        { header: 'Tap Type', width: 10, accessor: 'tap_type', sortable: false },
        { header: 'Actions', accessor: 'actions', action: true },
    ];

    const modifiedData = useMemo(() => {
        if (!data || !data.results) return [];
        return data.results.map((item: Customer) => ({
            ...item,
            member_sn: item.member_sn,
            mem_name: item.mem_name,
            spouse_name: item.spouse_name,
            add_eng: item.add_eng,
            add_nep: item.add_nep,
            ward_no: item.ward_no,
            phone_no: item.phone_no,
            dob: item.dob,
            province_name: item.province_name,
            tole_name: item.tole_name,
            father_name: item.father_name,
            reg_date_n: item.reg_date_n,
            meter_conn_date: item.meter_conn_date,
            meter_status_name: item.meter_status === 1 ? "Active" : 'Process..',
            meter_status: item.meter_status,
            tap_status_name: item.tap_status === 1 ? "Bigreko" : item.tap_status === 2 ? "Khapat Nabhayako" : item.tap_status === 3 ? "Sewa Banda" : "No Status",
            tap_status: item.tap_status,
            gender: item.gender,
            gender_name:item.gender=== 1 ? "Male" : item.gender === 2 ? "Female" : "Others",
            tap_no: item.tap_no,
            family_male_no: item.family_male_no,
            family_female_no: item.family_female_no,
            tap_type: item.tap_type,
            active: item.active,
            actions: '' // Placeholder for action buttons or links
        }));
    }, [data]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (error) {
        return <p>Error loading data: {error}</p>;
    }
    const handleEdit = (item: Customer) => {
        setCurrentItem(item);
        setDialogOpen(true);
    };
    return (
        <Fragment>
            <AppTable
                columns={columns}
                data={modifiedData}
                onEdit={handleEdit}
                onNext={() => data?.next && setOnURL(data.next)}
                onPrev={() => data?.previous && setOnURL(data.previous)}
            />
            <ConsumerEditView setDialogOpen={setDialogOpen} dialogOpen={dialogOpen} currentItem={currentItem} handleFormSuccess={handleFormSuccess} />
        </Fragment>
    );
};

export default CustomerListView;
